import { render, staticRenderFns } from "./CountUpNumber.vue?vue&type=template&id=640e6878"
import script from "./CountUpNumber.vue?vue&type=script&lang=ts"
export * from "./CountUpNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports